import cn from "classnames"
import React, { useState } from "react"
import ExampleList from "./example_list"
import { type BlockProps } from "."
import { graphql, getFragment } from "@/api"

export const ExampleCarouselFragment = graphql(`
  fragment FrontpagesExampleCarousel on FrontpagesExampleCarousel {
    id
    heading

    tabs {
      id
      heading

      exampleCarouselExamples {
        id

        example {
          id

          ...FrontpageExampleListExample_Example
        }
      }
    }
  }
`)

const ExampleCarouselBlock: React.FC<BlockProps<typeof ExampleCarouselFragment>> = ({ blockable, businessRole }) => {
  const block = getFragment(ExampleCarouselFragment, blockable)
  const [activeTab, setActiveTab] = useState(0)
  const examples = block.tabs[activeTab]?.exampleCarouselExamples.map(e => e.example) || []

  return (
    <>
      <div className="container pt-4">
        <h3 className="heading-three mb-6 lg:mb-4">{block.heading}</h3>

        {block.tabs.length > 1 && (
          <>
            <div className="hidden flex-wrap items-end justify-start border-b border-white-10 lg:flex">
              {block.tabs.map((tab, i) => (
                <div
                  key={tab.id}
                  className={cn(
                    "-mb-px w-auto cursor-pointer whitespace-nowrap border-b-2 py-2 pl-2 pr-8 text-base font-semibold",
                    {
                      "border-transparent text-ink-50 hover:border-b-white-20 hover:text-ink-100": i !== activeTab,
                      "border-blue-500 text-ink-100 hover:border-blue-600 hover:text-ink-85": i === activeTab,
                    }
                  )}
                  onClick={() => setActiveTab(i)}
                  data-gtm="fp-item-section-tab"
                >
                  {tab.heading}
                </div>
              ))}
            </div>

            <div className="lg:hidden">
              <select className="form-control" value={activeTab} onChange={e => setActiveTab(parseInt(e.target.value))}>
                {block.tabs.map((tab, i) => (
                  <option key={tab.id} value={i}>
                    {tab.heading}
                  </option>
                ))}
              </select>
            </div>
          </>
        )}

        <div className="hidden pb-4 pt-6 lg:block">
          <ExampleList
            examples={examples}
            businessRole={businessRole}
            gtmTag="fp-item-section-item"
            buttonsOutside
            moreButtonGtmTag="fp-item-section-more"
          />
        </div>
      </div>

      <div className="mt-6 lg:hidden">
        <ExampleList
          examples={examples}
          businessRole={businessRole}
          gtmTag="fp-item-section-item"
          moreButtonGtmTag="fp-item-section-more"
        />
      </div>
    </>
  )
}

export default ExampleCarouselBlock
